<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      <v-spacer></v-spacer>
      <MgmtButtons
        :view="view"
        :acl="acl"
        :system="item.system"
        @createItem="createItem"
        @deleteItem="deleteItem"
        @cloneItem="cloneItem"
        @toView="toView"
        @toEdit="toEdit"
        :clone="true"
        :templates="templates"
      />
      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab href="#system" @click="activeTab = 'system'">Системные</v-tab>

        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
            <v-row no-gutters class="tab-row">
              <v-col :cols="cols13">
                <v-card v-if="item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="red--text">Шаблон: {{ item.template_name }}</v-card-title>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Информация</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Номер:</th>
                        <td>{{ item.counter_view }}</td>
                      </tr>
                      <tr>
                        <th>Дата создания:</th>
                        <td>{{ item.date_created }}</td>
                      </tr>
                      <tr>
                        <th>Контрагент:</th>
                        <td>
                          <router-link v-if="item.client" :to="{ name: 'client_view', params: { id: item.client.id }}">
                            {{ item.client.name }}
                          </router-link>
                          <span v-else>---</span>
                        </td>
                      </tr>

                      <tr>
                        <th>Название:</th>
                        <td>{{ item.title }}</td>
                      </tr>
                      <tr>
                        <th>Объект (адрес):</th>
                        <td>{{ item.sec_object_address }}</td>
                      </tr>
                      <tr>
                        <th>Кол-во постов:</th>
                        <td>{{ item.post_count }}</td>
                      </tr>
                      <tr>
                        <th>Подразделение:</th>
                        <td>
                          <router-link v-if="item.subdivision" :to="{ name: 'subdivision_view', params: { id: item.subdivision.id }}">
                            {{ item.subdivision.name }}
                          </router-link>
                          <span v-else>---</span>
                        </td>
                      </tr>

                      <tr>
                        <th>Источник сделки:</th>
                        <td>{{ item.source_deal ? item.source_deal.name : '---' }}</td>
                      </tr>
                      <tr>
                        <th>Примечание:</th>
                        <td>{{ item.note }}</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Файлы</v-card-title>
                    <div class="redactor-field">
                      <MediaList
                        :id="item.id"
                        :acl="acl"
                        :view="view"
                        v-model="item.files"
                      ></MediaList>
                    </div>
                </v-card>
              </v-col>

              <v-col :cols="cols13">
                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Сделка</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Организация:</th>
                        <td>{{ item.organization ? item.organization.name : '---' }}</td>
                      </tr>
                      <tr>
                        <th>Система налогообложения:</th>
                        <td>{{ item.taxation_system ? item.taxation_system.name : '---' }}</td>
                      </tr>

                      <tr>
                        <th>Стоимость услуг:</th>
                        <td>{{ item.service_cost }} руб. {{ item.payment_frequency ? item.payment_frequency.name : '' }}</td>
                      </tr>

                      <tr>
                        <th class="view-table-list">Требуемые услуги:</th>
                        <td>
                          <ul class="view-table-list">
                            <li v-for="service in item.provided_services" :key="service.id">
                              <router-link :to="{ name: 'provided_services_view', params: { id: service.id }}">{{ service.name }}</router-link>
                            </li>
                          </ul>
                        </td>
                     </tr>

                    </table>
                  </v-card-text>
                </v-card>

                <v-card light v-if="item.client && item.client.contact_units.length > 0" class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Контактные лица</v-card-title>
                  <v-card-text>
                    <div v-for="(entry, index) in item.client && item.client.contact_units" v-bind:key="entry.id">
                      <table class="view-table" width="100%" >
                        <tr>
                          <th>ФИО:</th>
                          <td>{{ entry.fio }}</td>
                        </tr>
                        <tr>
                          <th>Телефон:</th>
                          <td>{{ entry.phone }}</td>
                        </tr>
                        <tr>
                          <th>Эл. почта:</th>
                          <td>{{ entry.email }}</td>
                        </tr>
                        <tr>
                          <th>Дата рождения:</th>
                          <td>{{ entry.born_date }}</td>
                        </tr>
                        <tr>
                          <th>Должность:</th>
                          <td>{{ entry.position }}</td>
                        </tr>
                        <tr>
                          <th></th>
                          <td></td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </v-card>

<!--                 <v-card light v-if="item.contact_units && item.contact_units.length > 0" class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Контактные лица</v-card-title>
                  <v-card-text>
                    <div v-for="(entry, index) in item.contact_units" v-bind:key="entry.id">
                      <table class="view-table" width="100%" >
                        <tr>
                          <th>ФИО:</th>
                          <td>{{ entry.fio }}</td>
                        </tr>
                        <tr>
                          <th>Телефон:</th>
                          <td>{{ entry.phone }}</td>
                        </tr>
                        <tr>
                          <th>Эл. почта:</th>
                          <td>{{ entry.email }}</td>
                        </tr>
                        <tr>
                          <th>Дата рождения:</th>
                          <td>{{ entry.born_date }}</td>
                        </tr>
                        <tr>
                          <th>Должность:</th>
                          <td>{{ entry.position }}</td>
                        </tr>
                        <tr>
                          <th></th>
                          <td></td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </v-card> -->

              </v-col>

              <v-col :cols="cols13">
                <v-card v-if="!isNew && !item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Статус</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Текущий:</th>
                        <td>{{ item.status_ru }}</td>
                      </tr>
                      <tr>
                        <th>Изменить:</th>
                        <td><Status :items="item.available_statuses" @changeStatus="changeStatus" :pendingStatus="pendingStatus" /></td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card v-if="['contract_preparation', 'contract_negotiation', 'success', 'cancel'].includes(item.status)" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Задача прав. центра:</th>
                        <td>
                          <div v-if="item.legalcenter">
                            <router-link :to="{ name: 'legalcenter_view', params: { id: item.legalcenter.id }}">{{ item.legalcenter.name }} ({{ item.legalcenter.status_ru }})</router-link>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card v-if="item.disagreements" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th><span class="red--text">Наличие разногласий:</span></th>
                        <td>{{ item.disagreements }}</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Участники</v-card-title>
                  <v-card-text>

                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Автор:</th>
                        <td>
                          <div v-if="item.author">
                            <NeedWatch :check_time="item.check_this_persons[item.author.id]" />
                            <router-link :to="{ name: 'address_book_view', params: { id: item.author.userinfo.id }}">{{ item.author.name }}</router-link>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Постановщик:</th>
                        <td>
                          <div v-if="item.responsible">
                            <NeedWatch :check_time="item.check_this_persons[item.responsible.id]" />
                            <router-link :to="{ name: 'address_book_view', params: { id: item.responsible.userinfo.id }}">{{ item.responsible.name }}</router-link>
                          </div>
                         </td>
                      </tr>

                      <tr>
                        <th>Приоритет:</th>
                        <td>{{ item.priority_ru }}</td>
                      </tr>
                      <tr>
                        <th class="view-table-list">Наблюдатели:</th>
                        <td>
                          <ul class="view-table-list">
                            <li v-for="watcher in item.watchers_list" :key="watcher.id">
                              <NeedWatch :check_time="item.check_this_persons[watcher.id]" />
                              <router-link :to="{ name: 'address_book_view', params: { id: watcher.userinfo.id }}">{{ watcher.name }}</router-link>
                            </li>
                          </ul>
                        </td>
                        <td valign="center" align="right">
                          <NewWatchers
                            v-if="current_user.id === (item.assigned && item.assigned.id)"
                            :id="item.id"
                            :url="urlObj"
                            :item="item"
                            @load="load"
                          />
                        </td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Комментарии</v-card-title>
                    <div class="redactor-field">
                      <Comments :url="urlObj" :id="id" :initialComments="item.comments" @setCheckThisOut="setCheckThisOut"></Comments>
                    </div>
                </v-card>

              </v-col>

            </v-row>
          </v-tab-item>

          <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
            <v-row no-gutters class="tab-row">
              <v-col :cols="cols125">
                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-text>
                    <table class="view-table">
                      <tr>
                        <th>Создан:</th>
                        <td>{{ item.created_by_name }}</td>
                      </tr>
                      <tr>
                        <th>Дата создания:</th>
                        <td>{{ item.date_created }}</td>
                      </tr>
                      <tr>
                        <th>Изменен:</th>
                        <td>{{ item.modified_by_name || '---' }}</td>
                      </tr>
                      <tr>
                        <th>Дата изменения:</th>
                        <td>{{ item.date_modified || '---' }}</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </StaticTabs>
    </v-col>

    <v-col :cols="colsBar">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <CRMFilter
          class="user-filter"
          :query="initialQuery"
          :count="count"
          :filterPending="filterPending"
          :countTotal="countTotal"
          @filteredLoad="filteredLoadCollbar"
          :acl="acl"
        />

      </v-row>
      <hr />
      <CollectionBar
        :id="item.id"
        :items="coll"
        :count="count"
        :loading="loadingCollbar"
        :scrollBusy="scrollBusy"
        @loadCollbar="loadCollbar"
        @toEdit="toEdit"
        @toView="toView"
      />
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import { get, edit, PREFIX } from '@/api'
import CRMFilter from '@/components/filters/CRMFilter'
import ViewMixin from '@/views/View.vue'
import TaskMixin from '@/views/Task.vue'
import MediaList from '@/components/MediaList'
import Comments from '@/components/Comments'
import Status from '@/components/Status'
import NeedWatch from '@/components/NeedWatch'
import NewWatchers from '@/components/NewWatchers'
import NewAssigned from '@/components/NewAssigned'
import ContactUnitList from '@/components/ContactUnitList'

export default {
  mixins: [ViewMixin, TaskMixin],
  components: {
    CRMFilter,
    ContactUnitList,
    Comments,
    MediaList,
    Status,
    NeedWatch,
    NewWatchers,
    NewAssigned
  },
  computed: {
  },
  data: function () {
    return {
      // default filter
      initialQuery: {
      },

      modelName: 'CRM',
      viewName: 'crm',
      viewTitle: 'CRM',
      parentHref: '#/crm',

      urlObj: 'crm/',
      urlList: 'crms/',
      // item
      item: {
        id: this.id,
        name: '',
        available_statuses: [{ name: '', value: null }],
        check_this_persons: {}
      },
      // collbar
      collbar: {
        url: 'crms/',
        name: 'crm'
      },
      // pending
      pendingStatus: false,
      // error
      statusError: ''
    }
  },
  methods: {
    setCheckThisOut (data) {
      this.item.check_this_persons = data
    }
  },
}
</script>
<style scoped>
.task-text {
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
}
</style>
